import { DAYS } from "./Cont";

export const getDaysInMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};

export const range = (end) => {
  const { result } = Array.from({ length: end }).reduce(
    ({ result, current }) => ({
      result: [...result, current],
      current: current + 1,
    }),
    { result: [], current: 1 }
  );
  return result;
};
export const getMonthData = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const lastDate = new Date(year, month + 1, 0).getDate();

  const result = new Array(42).fill(null);

  for (let i = 0; i < lastDate; i++) {
    result[firstDay + i] = {
      date: i + 1,
      fullDate: new Date(year, month, i + 1),
    };
  }

  return result;
};

export const sortDays = (date) => {
  const dayIndex = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  const sortedDays = [...DAYS.slice(dayIndex), ...DAYS.slice(0, dayIndex)];
  return sortedDays;
};

// export const datesAreOnSameDay = (first, second) =>
//   first.getFullYear() === second.getFullYear() &&
//   first.getMonth() === second.getMonth() &&
//   first.getDate() === second.getDate();

export const datesAreOnSameDay = (first, second) => {
  // if( first.getFullYear() === second.getFullYear() &&
  // first.getMonth() === second.getMonth() &&
  // first.getDate() === second.getDate())
  // alert(first)
  return (
    // first.getFullYear() === second.getFullYear() &&
    // first.getMonth() === second.getMonth() &&
    // first.getUTCDate() === second.getUTCDate()
    first.getUTCFullYear() === second.getUTCFullYear() &&
    first.getUTCMonth() === second.getUTCMonth() &&
    first.getUTCDate() === second.getUTCDate()
  );
};
export const getMonthYear = (date) => {
  const d = date.toDateString().split(" ");
  return `${d[1]} ${d[3]}`;
};

export const nextMonth = (date, cb) => {
  const mon = date.getUTCMonth();
  if (mon < 11) {
    date.setMonth(mon + 1);
  } else {
    date.setMonth(0);
    date.setFullYear(date.getUTCFullYear() + 1);
  }
  cb(new Date(date));
};

export const prevMonth = (date, cb) => {
  const mon = date.getUTCMonth();
  if (mon > 0) {
    date.setMonth(mon - 1);
  } else {
    date.setMonth(11);
    date.setFullYear(date.getUTCFullYear() - 1);
  }
  cb(new Date(date));
};

export const getDarkColor = () => {
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += Math.floor(Math.random() * 10);
  }
  return color;
};

export const getSortedDays = (date) => {
  const daysInMonth = range(getDaysInMonth(date));
  const index = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  return [...Array(index === 0 ? 6 : index - 1), ...daysInMonth];
};
